import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, Box, CircularProgress } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import { WebSocketProvider } from './context/WebSocketContext';
import { ThemeProvider } from './context/ThemeContext';
import PrivateRoute from './components/PrivateRoute';

// Lazy loading de páginas para mejor performance
const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const BandejaDetalle = lazy(() => import('./pages/BandejaDetalle'));
const Configuracion = lazy(() => import('./pages/Configuracion'));
const Alertas = lazy(() => import('./pages/Alertas'));
const Estadisticas = lazy(() => import('./pages/Estadisticas'));
const CiclosComparacion = lazy(() => import('./pages/CiclosComparacion'));
const CiclosHistorial = lazy(() => import('./pages/CiclosHistorial'));
const Rentabilidad = lazy(() => import('./pages/Rentabilidad'));
const AlertasInteligentes = lazy(() => import('./pages/AlertasInteligentes'));
const Predicciones = lazy(() => import('./pages/Predicciones'));
const Tareas = lazy(() => import('./pages/Tareas'));
const Comparador = lazy(() => import('./pages/Comparador'));
const ControlManual = lazy(() => import('./pages/ControlManual'));
const BackupRestore = lazy(() => import('./pages/BackupRestore'));
const Comparativa = lazy(() => import('./pages/Comparativa'));
const Recetas = lazy(() => import('./pages/Recetas'));
const Calendario = lazy(() => import('./pages/Calendario'));
const Analisis = lazy(() => import('./pages/Analisis'));
const ExportarPDF = lazy(() => import('./pages/ExportarPDF'));
const Notificaciones = lazy(() => import('./pages/Notificaciones'));
const Diagnostico = lazy(() => import('./pages/Diagnostico'));
const InventarioSimple = lazy(() => import('./pages/InventarioSimple'));
const HistorialComandos = lazy(() => import('./pages/HistorialComandos'));

// Componente de loading mientras se cargan las páginas
const LoadingFallback = () => (
  <Box 
    display="flex" 
    justifyContent="center" 
    alignItems="center" 
    minHeight="100vh"
    bgcolor="#f5f5f5"
  >
    <CircularProgress size={60} style={{ color: '#2e7d32' }} />
  </Box>
);

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <WebSocketProvider>
          <BrowserRouter>
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                <Route path="/bandeja/:id" element={<PrivateRoute><BandejaDetalle /></PrivateRoute>} />
                <Route path="/configuracion/:id" element={<PrivateRoute><Configuracion /></PrivateRoute>} />
                <Route path="/alertas" element={<PrivateRoute><Alertas /></PrivateRoute>} />
                <Route path="/estadisticas" element={<PrivateRoute><Estadisticas /></PrivateRoute>} />
                <Route path="/ciclos-comparacion" element={<PrivateRoute><CiclosComparacion /></PrivateRoute>} />
                <Route path="/ciclos-historial" element={<PrivateRoute><CiclosHistorial /></PrivateRoute>} />
                <Route path="/rentabilidad" element={<PrivateRoute><Rentabilidad /></PrivateRoute>} />
                <Route path="/alertas-inteligentes" element={<PrivateRoute><AlertasInteligentes /></PrivateRoute>} />
                <Route path="/predicciones/:id" element={<PrivateRoute><Predicciones /></PrivateRoute>} />
                <Route path="/tareas" element={<PrivateRoute><Tareas /></PrivateRoute>} />
                <Route path="/comparador" element={<PrivateRoute><Comparador /></PrivateRoute>} />
                <Route path="/control-manual" element={<PrivateRoute><ControlManual /></PrivateRoute>} />
                <Route path="/backup" element={<PrivateRoute><BackupRestore /></PrivateRoute>} />
                <Route path="/comparativa" element={<PrivateRoute><Comparativa /></PrivateRoute>} />
                <Route path="/recetas" element={<PrivateRoute><Recetas /></PrivateRoute>} />
                <Route path="/calendario" element={<PrivateRoute><Calendario /></PrivateRoute>} />
                <Route path="/analisis" element={<PrivateRoute><Analisis /></PrivateRoute>} />
                <Route path="/exportar" element={<PrivateRoute><ExportarPDF /></PrivateRoute>} />
                <Route path="/notificaciones" element={<PrivateRoute><Notificaciones /></PrivateRoute>} />
                <Route path="/diagnostico" element={<PrivateRoute><Diagnostico /></PrivateRoute>} />
                <Route path="/inventario" element={<PrivateRoute><InventarioSimple /></PrivateRoute>} />
                <Route path="/historial-comandos" element={<PrivateRoute><HistorialComandos /></PrivateRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </WebSocketProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
